import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'

const unauthorizedCode = [401]

const FormService = axios.create({
    timeout: 180000,
    baseURL: appConfig.apiPrefix,
})

FormService.interceptors.request.use(config => {

    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
    const persistData = deepParseJson(rawPersistData)
    
    const accessToken = persistData.auth.session.token

    if (accessToken) {
        config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`
    }

    // Let axios/browser automatically set Content-Type with boundary for FormData
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type']
    } else if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'multipart/form-data'
    }
    
    return config
}, error => {
    return Promise.reject(error)
})

FormService.interceptors.response.use(
    response => response,
    error => {

        const { response } = error

        if (response && unauthorizedCode.includes(response.status)) {
            // do something with the unauthorized response
        }

        return Promise.reject(error)
    }
)

export default FormService
